module.exports = __webpack_public_path__ + "img/cohete.f76372fd.png";